/*
 * Digital Purchase Order
 *
 * Copyright (c) 2017 LeBog Software GmbH, Germany.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are not permitted.
 */
//@flow


import {DialogTitleBarButton} from "./Controls/DialogTitleBarButton";

/**
 *
 * @param data
 * @param property
 * @param defaultValue
 * @return {*}
 */
export function safeRead(data: Object, property: string, defaultValue: any, defaultOnNull: boolean) {

	if (defaultValue === undefined) {
		defaultValue = null;
	}
	if (property === undefined || property == null) {
		return defaultValue;
	}

	if (data == null) {
		return defaultValue;
	}

	//split property and recursively search for value
	let properties = property.split('.')

	let firstProperty = properties.shift();

	if (!firstProperty) {
		return defaultValue;
	}

	if (data[firstProperty] === undefined || (defaultOnNull && data[firstProperty] === null)) {
		return defaultValue;
	}

	if (properties.length > 0) {
		if (data[firstProperty] instanceof Object && (!Array.isArray(data[firstProperty]))) {
			return safeRead(data[firstProperty], properties.join('.'), defaultValue, defaultOnNull);
		}
	}

	return data[firstProperty];
};


export function dialogAddTitlebarButton(dialog, icon, cssClass, tooltip, visible, placeholder) {
	// var iconHtml = '';
	//
	// if (typeof placeholder == 'undefined') {
	// 	placeholder = true;
	// }
	// if (icon) {
	// 	if (Array.isArray(icon) || icon.substring(0,3) == 'fa-') {
	// 		// font awesome icon(s)
	// 		if (Array.isArray(icon)) {
	// 			// multiple icons stacked
	// 			iconHtml = '<span class="fa-stack">';
	// 			$.each(icon, function(index, iconname) {
	// 				iconHtml += '<i class="fa fa-stack-1x ' + iconname + '"></i>';
	// 			});
	// 			iconHtml += '</span>';
	// 		} else {
	// 			// single icon
	// 			iconHtml = '<i class="fa ' + icon + '"></i>';
	// 		}
	// 	} else {
	// 		// jquery-UI icons
	// 		if (icon.substring(0,8) != 'ui-icon-') {
	// 			icon = 'ui-icon-' + icon;
	// 		}
	//
	// 		iconHtml = '<span class="ui-icon ui-button-icon-primary ' + icon + '"></span>';
	// 	}
	// }
	//
	// // Erzeuge den einzufügenden Button
	// var button = $('<button type="button" class="' + cssClass + ' ui-button-icon-only" title="' + tooltip + '">'+ iconHtml + '<div></div></button>');
	//
	// if (!visible) {
	// 	button.css('display', 'none');
	// }
	//
	// var container = dialog.parent().find('.dpo-ui-dialog-title-button-container');
	//
	// if (container.length == 0) {
	// 	container = $('<span class="dpo-ui-dialog-title-button-container"></span>');
	// 	dialog.parent().find('.ui-dialog-title').before(container);
	// }
	//
	// container.append(button);
	//
	//
	//
	// var plcHolder = dialog.parent().find('.' +
	// 	'ui-dialog-titlebar-close-placeholder');
	//
	// if (plcHolder.length == 0 && placeholder) {
	// 	dialog.parent().find('.ui-dialog-titlebar-close').before('<div class="ui-dialog-titlebar-close-placeholder"></div>');
	// }
	//
	// return button;

	return new DialogTitleBarButton(dialog, icon, cssClass, tooltip, visible, placeholder);
};

/**
 *  takes a plain object and converts it into a Map of dotted path and their
 *  respective values
 *
 * @param data
 * @param basePath
 * @returns {[]}
 */
export function dottify(data: Object, map: Map<string,  any>, basePath =[]): Map<string,  any> {
	// let result = new Map();

	if (!map) {
		map = new Map();
	}
	let pathElems = [];

	for (let prop in data) {
		if (data[prop] instanceof Object && !Array.isArray(data[prop])) {
			dottify(data[prop], map, basePath.concat([prop]));
		} else {
			// this is a leaf
			map.set(basePath.concat([prop]).join('.'), data[prop]);
		}
	}

	return map;
}


/**
 * takes a map with dotted paths + their values ands converts into a plain object
 * @param data
 * @returns {{}}
 */
export function undottify(data: Map<string,  any>): Object {
	let result = {};

	data.forEach((value, path) => {
		// set start point to base
		let current = result;

		// look at a single path (with value)
		// split path into separate parts (i.e., 'Filter.Status' => ['Filter', 'Status'])
		path.split('.').forEach((part, index, arr) => {

			if (arr.length === index + 1) {
				// this is the last part of the path, the leaf
				// set property to the provided path's value
				current[part] = value;
			} else {
				// not the leaf yet
				if (!(current[part] instanceof Object)) {
					// part doesn't exit yet, create empty object
					current[part] = {};
				}

				current = current[part];
			}
		});
	});

	return result;
}

// var changePasswordFieldType = function(element, type) {
// 	var newElem = element.clone();
// 	newElem.attr('type', type);
// 	newElem.insertBefore(element);
// 	element.remove();
// };


let jQ = $;

/***
 *
 * @param subordinates
 */
jQ.whenAll = function(...subordinates: Object) {
	let masterDfd = $.Deferred();

	// see if any arguments are arrays and treat them as arrays of promised,
	// flattening down the first sub level



	let promises = subordinates.filter((s) => !Array.isArray(s));
	subordinates.filter((s) => Array.isArray(s)).forEach((s) => (s).forEach((sub) => promises.push(sub)));

	let remaining = promises.length;


	let resolveContexts =new Array(length);
	let progressContexts =new Array(length);
	let rejectContexts = new Array(length);
	let progressValues = new Array(length);
	let resolveValues = new Array(length);
	let rejectValues = new Array(length);
	let masterResolve=true;

	let updateFunc = function(i, contexts, values, callType) {
		return function (value) {
			contexts[i] = this;
			values[i] = arguments.length > 1 ? Array.prototype.slice.call(arguments) : value;

			switch(callType) {
				case 'progress':
					masterDfd.notifyWith(contexts, values);
					break;
				case 'reject':
					masterResolve = false;
				case 'resolve':
					if (! (--remaining)) {
						if (masterResolve) {
							masterDfd.resolveWith(resolveContexts, resolveValues);
						} else {
							masterDfd.rejectWith(rejectContexts, rejectValues);
						}
					}
					break;

			}
		};
	};

	let i = 0;
	for(let promise of promises) {
		if (promise && (typeof promise.promise  === "function")) {
			promise.promise()
				.done(updateFunc(i, resolveContexts, resolveValues, 'resolve'))
				.fail(updateFunc(i, rejectContexts, rejectValues, 'reject'))
				.progress(updateFunc(i, progressContexts, progressValues, 'progress'));
		} else {
			--remaining;
		}
		i++;
	}

	if (!remaining) {
		masterDfd.resolveWith(resolveContexts, resolveValues);
	}
	return masterDfd.promise();
};

export { jQ }


